import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../web/components-v2/Theme/theme';
import { shadowSm } from '../../../../web/styles/shadows';

const { colors } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[24],
		maxWidth: 1000,
		width: '100%',
	},
	actionsBar: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	list: {
		border: `1px solid ${colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		boxShadow: shadowSm,
		display: 'flex',
		flexDirection: 'column',
	},
	row: {
		alignItems: 'center',
		borderBottom: `1px solid ${colors.border.light}`,
		display: 'flex',
		fontSize: THEME.typography.fontSizes.sm,
		gap: SPACE[24],
		padding: `${SPACE[20]}px ${SPACE[24]}px`,
		position: 'relative',
		':last-child': {
			borderBottom: 'none',
		},
	},
	rowBlocked: {
		backgroundColor: colors.background.light,
		inset: 0,
		opacity: 0.6,
		position: 'absolute',
	},
	name: {
		display: 'flex',
		flex: 1,
		minWidth: 0,
	},
	colorGroup: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[12],
	},
	swatches: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[12],
	},
	swatch: {
		border: 'none',
		borderRadius: '50%',
		cursor: 'pointer',
		height: 16,
		padding: 0,
		width: 16,
	},
	swatchSelected: {
		boxShadow: `0 0 0 2px ${colors.background.light}, 0 0 0 4px ${colors.text.main}`,
	},
	label: {
		color: colors.text.light,
	},
	usageGroup: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[8],
		minWidth: 190,
	},
	usage: {
		fontWeight: THEME.typography.fontWeights.bold,
	},
	nameInput: {
		width: '100%',
	},
});
